/**
 * Helpers for when location-tag API calls are allowed (#999).
 */

export function isOfflineClientRequestId(
  requestId: string | null | undefined,
): boolean {
  return Boolean(requestId?.startsWith('o-'));
}

/** Explicit Create Request sentinels — not a missing id. */
export function isExplicitDraftLocationTagRequestId(
  requestId: string | null | undefined,
): boolean {
  return requestId === 'new-request' || requestId === 'new';
}

/**
 * Id for Create Request's RequestStageProvider.
 * Use here only — never on step `requestId`, which would call `/requests/new-request/...`.
 * Empty `formData.id` must stay `'new-request'` so Location Tag mutation does not fail-close (#1472).
 */
export function resolveCreateRequestStageRequestId(
  persistedRequestId: string | number | null | undefined,
): string {
  return persistedRequestId ? String(persistedRequestId) : 'new-request';
}

export function isDraftLocationTagRequestId(
  requestId: string | null | undefined,
): boolean {
  if (!requestId) {
    return true;
  }
  return isExplicitDraftLocationTagRequestId(requestId);
}

export function isPersistedServerRequestId(
  requestId: string | null | undefined,
): boolean {
  if (!requestId) {
    return false;
  }
  if (isDraftLocationTagRequestId(requestId)) {
    return false;
  }
  if (isOfflineClientRequestId(requestId)) {
    return false;
  }
  return /^\d+$/.test(requestId);
}
